module.exports = __webpack_public_path__ + "images/emoji/violin.9a9dfe21b56399fe9f08.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/violin.png
// module id = 0/SI
// module chunks = 2